import _ from 'lodash'
const searchMethod = (item, column, condition) => {
  if (!condition) {
    return true
  }
  if (item.alwayShowItem_) {
    return true
  }

  for (let i = 0; i < column.children.column.length; i++) {
    let fieldConfig = column.children.column[i]
    if (needSearch(fieldConfig, condition)) {
      if (fieldConfig.searchWay === 'like') {
        if (!strLike(item[fieldConfig.prop], condition[fieldConfig.prop])) {
          return false
        }
      } else if (fieldConfig.type === 'checkbox' || (fieldConfig.type === 'select' && fieldConfig.multiple)) {
        if (!containItem(item[fieldConfig.prop], condition[fieldConfig.prop])) {
          return false
        }
      } else if (item[fieldConfig.prop] !== condition[fieldConfig.prop]) {
        return false
      }
    }
  }
  return true
}

const strLike = (fieldValue, keyword) => {
  return fieldValue.indexOf(keyword) >= 0
}

const needSearch = (fieldConfig, condition) => {
  return fieldConfig.isSearch && condition[fieldConfig.prop]
}

const containItem = (fieldValue, keyword) => {
  return _.indexOf(fieldValue, keyword) >= 0
}

export {
  searchMethod
}
